import api from './api'

export const emailAuditLogService = {
  getAuditLogs: async (params) => {
    const response = await api.get('/email-audit-log', { params })
    return response.data
  }
}
